import { render } from "./CreateOrderPage.vue?vue&type=template&id=6e1e260b&ts=true"
import script from "./CreateOrderPage.vue?vue&type=script&lang=ts"
export * from "./CreateOrderPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__